var exports = {
  "WC": "xaf9ae18d--e965c7--department-link-wrapper",
  "bZ": "xaf9ae18d--e965c7--rate-mark-wrapper",
  "a_": "xaf9ae18d--e965c7--terms",
  "Pf": "xaf9ae18d--e965c7--label",
  "q3": "xaf9ae18d--e965c7--indicator",
  "TS": "xaf9ae18d--e965c7--rate",
};

module.exports = exports;
